// extracted by mini-css-extract-plugin
export var siteHeader = "SiteHeader-module--siteHeader--jXI4Y";